// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c3b80d3c","465":"c98b282c","787":"fa3c4679","876":"0491f7e7"}[chunkId] + ".chunk.js";
};